import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StrategyRoutingModule } from './strategy-routing.module';
import { ToggleSwitchModule } from 'src/app/shared/toggle-switch/toggle-switch.module';
import { EditInstrumentsComponent } from 'src/app/pages/strategy/edit-instruments/edit-instruments.component';
import { NewStrategyComponent } from 'src/app/pages/strategy/new-strategy/new-strategy.component';
import { PreloadSpinnerModule } from 'src/app/shared/preload-spinner/preload-spinner.module';
import { ModelStrategyCarouselModule } from 'src/app/shared/model-strategy-carousel/model-strategy-carousel.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'src/app/shared/button/button.module';
import { TooltipButtonModule } from 'src/app/shared/tooltip-button/tooltip-button.module';
import { PlusMinusInputModule } from 'src/app/shared/plus-minus-input/plus-minus-input.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectedInstrumentTogglerComponent } from 'src/app/shared/selected-instrument-toggler/selected-instrument-toggler.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { InstrumentChartCarouselModule } from 'src/app/shared/charts/instrument-chart-carousel/instrument-chart-carousel.module';
import { InstrumentChartDropdownModule } from 'src/app/shared/charts/instrument-chart-card/instrument-chart-dropdown/instrument-chart-dropdown.module';
import { TextInputModule } from 'src/app/shared/text-input/text-input.module';
import { RadioInputGroupModule } from 'src/app/shared/radio-input-group/radio-input-group.module';
import { BaseChartDirective } from 'ng2-charts';
import { HtmlFormatPipeModule } from 'src/app/pipes/html-format-pipe.module';
import { DipPickerModule } from 'src/app/shared/dip-picker/dip-picker.module';
import { StrategyPickerModule } from '../strategy-picker/strategy-picker.module';
import { InstrumentsChecksumInputModule } from 'src/app/shared/instruments-checksum-input/instruments-checksum-input.module';
import { StrategyInstrumentDropdownInputModule } from 'src/app/shared/strategy-instrument-dropdown-input/strategy-instrument-dropdown-input.module';
import { EntryFeeCalcModule } from 'src/app/shared/entry-fee-calc/entry-fee-calc.component.module';
import { ListableInstrumentsModule } from 'src/app/shared/listable-instruments/listable-instruments.module';
import { DevelopmentChartModule } from 'src/app/shared/charts/development-chart/development-chart.module';

@NgModule({
  declarations: [
    NewStrategyComponent,
    EditInstrumentsComponent,
    SelectedInstrumentTogglerComponent,
  ],
  imports: [
    StrategyPickerModule,
    CommonModule,
    ButtonModule,
    ToggleSwitchModule,
    StrategyRoutingModule,
    PreloadSpinnerModule,
    ModelStrategyCarouselModule,
    TranslateModule,
    TooltipButtonModule,
    PlusMinusInputModule,
    FormsModule,
    ReactiveFormsModule,
    AngularSvgIconModule,
    InstrumentChartCarouselModule,
    InstrumentChartDropdownModule,
    TextInputModule,
    RadioInputGroupModule,
    BaseChartDirective,
    HtmlFormatPipeModule,
    DipPickerModule,
    InstrumentsChecksumInputModule,
    StrategyInstrumentDropdownInputModule,
    EntryFeeCalcModule,
    ListableInstrumentsModule,
    DevelopmentChartModule,
  ],
  exports: [
    NewStrategyComponent,
    EditInstrumentsComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class StrategyModule { }
